import SidebarClaim from "./sidebarClaim";
import { getAllClaimByEvaluationPeriod } from "../../api/claim";
import { getAllLevel } from "../../api/pedagogicElement";
import { getAllEvaluationPeriodByLevel } from "../../api/generalParam";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { my_routes } from "../router/all_routes";
import { toast } from "sonner";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Avvvatars from "avvvatars-react";

const ClaimList = () => {
  const route = my_routes;
  const { selectedYear } = useAcademicYear();
  //Initialisation des state utilisés
  const [allLevel, setAllLevel] = useState<any[]>([]);
  const [selectedLevel, setSelectedLevel] = useState<any>();

  const [allEvaluationPeriod, setAllEvaluationPeriod] = useState<any[]>([]);
  const [selectEvaluationPeriod, setselectedEvaluationPeriod] = useState<any>();

  const [claims, setClaims] = useState<any[]>([]);
  const [filteredClaims, setFilteredClaims] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const [groupedClaims, setGroupedClaims] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);

  const [refreshKey, setRefreshKey] = useState(0);
  const [showCreate, setShowCreate] = useState(false);

  const status = [
    { id: "Envoyé", label: "Envoyées" },
    { id: "Traité", label: "Traitées" },
    { id: "Annulé", label: "Annulées" },
    { id: "Clôturé", label: "Clôturées" },
  ];

  //Reload de la liste
  const reloadData = () => setRefreshKey((prev) => prev + 1);

  const toggleStatus = (id: string) => {
    setSelectedStatus((prev) =>
      prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id],
    );
  };

  // fonction pour récuprérer toutes les niveaux d'une années académique
  const fetchAllLevel = async () => {
    try {
      if (!selectedYear) return;
      const res = await getAllLevel(
        selectedYear.id,
        buildPermissionContext(Resource.CLAIM, Action.READ),
      );
      setAllLevel(res.data || []);
      if (res.data && res.data.length > 0) {
        setSelectedLevel(res.data[0].id);
      }
    } catch (error: any) {
      toast.error("Erreur lors de la récupération des niveaux");
    }
  };

  // fonction pour récupérer toutes les périodes d'évaluation d'un niveau
  const fetchAllEvaluationPeriod = async () => {
    try {
      if (!selectedLevel) return;
      const res = await getAllEvaluationPeriodByLevel(
        selectedLevel,
        buildPermissionContext(Resource.CLAIM, Action.READ),
      );
      setAllEvaluationPeriod(res.data || []);
      if (res.data && res.data.length > 0) {
        setselectedEvaluationPeriod(res.data[0].id);
      }
    } catch (error: any) {
      toast.error("Erreur lors de la récupération des périodes d'évaluation");
    }
  };

  // fonction pour récupérer les réclamations de la période sélectionnée
  const fetchAllClaim = async () => {
    try {
      if (!selectEvaluationPeriod || !selectedYear) return;
      setIsLoading(true);
      const res = await getAllClaimByEvaluationPeriod(
        selectEvaluationPeriod,
        selectedYear.id,
        buildPermissionContext(Resource.CLAIM, Action.READ),
      );
      const data = res.data?.claims || [];
      // console.log("Response: ", data);

      setClaims(data);
      groupClaims(data);
    } catch (error: any) {
      toast.error("Erreur lors de la récupération des réclamations");
    } finally {
      setIsLoading(false);
    }
  };

  const groupClaims = (claimsList: any[]) => {
    const grouped = claimsList.reduce((acc: any, claim: any) => {
      const subjectUEId = claim.Note?.id_subjectUE;
      const studentId = claim.Note?.StudentProfil?.id;
      if (!acc[subjectUEId]) {
        acc[subjectUEId] = {
          subjectUE: claim.Note?.SubjectUE,
          claimsByStudent: [],
        };
      }
      if (
        !acc[subjectUEId].claimsByStudent.find(
          (s: any) => s.student.id === studentId,
        )
      ) {
        acc[subjectUEId].claimsByStudent.push({
          student: claim.Note?.StudentProfil,
          claims: [],
        });
      }
      acc[subjectUEId].claimsByStudent
        .find((s: any) => s.student.id === studentId)
        .claims.push(claim);
      return acc;
    }, {});
    setGroupedClaims(Object.values(grouped));
  };

  // fonction pour filtrer les réclamations en fonction du status
  const filterClaims = () => {
    let list = claims || [];

    if (selectedStatus.length > 0) {
      list = list.filter((claim) =>
        selectedStatus.includes(claim?.statut_claim),
      );
    }

    const q = searchTerm?.trim().toLowerCase();
    if (q) {
      list = list.filter((claim) => {
        const subject =
          claim?.Note?.SubjectUE?.Subject?.label ||
          claim?.Note?.SubjectUE?.label ||
          "";
        const student = `${claim?.Note?.StudentProfil?.firstname || ""} ${claim?.Note?.StudentProfil?.lastname || ""}`;
        const classLabel =
          claim?.Note?.StudentProfil?.Registrations?.[0]?.Class?.label || "";
        return (
          subject.toLowerCase().includes(q) ||
          student.toLowerCase().includes(q) ||
          classLabel.toLowerCase().includes(q)
        );
      });
    }

    setFilteredClaims(list);
    groupClaims(list);
  };

  useEffect(() => {
    fetchAllLevel();
  }, [selectedYear]);

  useEffect(() => {
    fetchAllEvaluationPeriod();
  }, [selectedLevel]);

  useEffect(() => {
    fetchAllClaim();
  }, [selectEvaluationPeriod, refreshKey]);

  useEffect(() => {
    filterClaims();
  }, [selectedStatus, claims, searchTerm]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Réclamations Étudiants</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={route.adminDashboard}>Accueil</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Réclamations
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Page Header */}

          <div
            className="bg-white p-3 rounded-1 d-flex align-items-center justify-content-between flex-wrap mb-4 pb-0"
            style={{ border: "1px solid #B5B9C3" }}
          >
            <div className="d-flex align-items-center flex-wrap gap-3 mb-3">
              <div style={{ minWidth: "200px" }}>
                <label className="form-label small fw-bold">Niveau</label>
                <select
                  className="form-select form-select-sm"
                  onChange={(e) => setSelectedLevel(e.target.value)}
                >
                  <option value="">Sélectionner un niveau</option>
                  {allLevel.map((l) => (
                    <option
                      key={l.id}
                      value={l.id}
                      selected={l.id === selectedLevel}
                    >
                      {l.label}
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ minWidth: "200px" }}>
                <label className="form-label small fw-bold">
                  Période d'évaluation
                </label>
                <select
                  className="form-select form-select-sm"
                  onChange={(e) => setselectedEvaluationPeriod(e.target.value)}
                >
                  <option value="">Sélectionner une période</option>
                  {allEvaluationPeriod.map((p) => (
                    <option
                      key={p.id}
                      value={p.id}
                      selected={p.id === selectEvaluationPeriod}
                    >
                      {p.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
              {/* Search box */}
              <div className="flex-grow-1" style={{ minWidth: "230px" }}>
                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-white border-end-0">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Rechercher matière, étudiant ou classe..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>

              {/* Dropdown Statust */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-light bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-filter me-2" />
                  Statuts
                </button>

                <ul
                  className="dropdown-menu p-2 shadow"
                  onClick={(e) => e.stopPropagation()}
                  style={{ minWidth: "200px" }}
                >
                  {status.map((st, idx) => (
                    <li key={idx} className="mb-1">
                      <label className="dropdown-item d-flex align-items-center gap-2 rounded">
                        <input
                          type="checkbox"
                          className="form-check-input m-0"
                          checked={selectedStatus.includes(st.id)}
                          onChange={() => toggleStatus(st.id)}
                        />
                        <span>{st.label}</span>
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Tickets */}
            <div className="col-xl-8 col-xxl-9">
              {isLoading ? (
                <div className="text-center py-5">
                  <div
                    className="spinner-border text-primary"
                    role="status"
                  ></div>
                  <p className="mt-2">Chargement des réclamations...</p>
                </div>
              ) : groupedClaims.length === 0 ? (
                <div className="card">
                  <div className="card-body text-center py-5">
                    <i className="ti ti-folder-off fs-40 text-muted mb-2"></i>
                    <p>Aucune réclamation trouvée pour cette période.</p>
                  </div>
                </div>
              ) : (
                groupedClaims.map((group: any) => (
                  <div
                    className="card mb-3 shadow-sm"
                    key={group.subjectUE?.id}
                  >
                    <div className="card-header d-flex align-items-center justify-content-between p-3">
                      <h5 className="text-primary mb-0">
                        {group.subjectUE?.Subject?.label || "Matière sans nom"}
                      </h5>
                    </div>
                    {group.claimsByStudent.map((s: any) => (
                      <div className="card-body p-3 pb-0">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                          <div className="d-flex align-items-center flex-wrap">
                            <span className="avatar avatar-xxl me-2 mb-3">
                              <Link
                                to={`/student-detail/${s.student?.id}`}
                                className="avatar avatar-xxl flex-shrink-0"
                                style={{ borderRadius: 0, overflow: "hidden" }}
                              >
                                <Avvvatars
                                  value={`${
                                    s.student?.firstname?.charAt(0) || ""
                                  }${s.student?.lastname?.charAt(0) || ""}`}
                                  style="character"
                                  size={80}
                                />
                              </Link>
                            </span>
                            <div className="mb-3">
                              <span className="badge bg-pending rounded-pill mb-1">
                                {s.claims?.length || 0} réclamation(s)
                              </span>
                              <div className="d-flex align-items-center mb-2">
                                <h5 className="fw-semibold me-2">
                                  <Link to={"#"}>
                                    {s.student?.firstname} {s.student?.lastname}
                                  </Link>
                                </h5>
                              </div>
                              <div className="d-flex align-items-center flex-wrap">
                                <p className="d-flex align-items-center me-2 mb-1">
                                  {s?.student?.matricule || "Non défini"}
                                  <span className="text-dark ms-1">
                                    {" "}
                                    {allLevel.find(
                                      (l: any) => l.id === selectedLevel,
                                    )?.abbreviation || "Non défini"}{" "}
                                    -{" "}
                                    {s?.student?.Registrations[0]?.Class
                                      ?.label || "Non défini"}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <Link
                              to={`${route.claimDetails.replace(":subjectUEId", group.subjectUE?.id).replace(":studentId", s.student?.id)}?periodId=${selectEvaluationPeriod}`}
                              className="btn btn-outline-info d-flex align-items-center h-1"
                            >
                              <i className="ti ti-eye me-1" />
                              Voir
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))
              )}
            </div>
            {/* /Tickets */}

            {/* Categories List */}
            <SidebarClaim claims={filteredClaims} />
            {/* /Categories List */}
          </div>
        </div>
      </div>
    </>
  );
};

export default withPermission(
  ClaimList,
  [
    buildPermission(Resource.CLAIM, Action.READ),
    buildPermission(Resource.CLAIM, Action.CREATE),
    buildPermission(Resource.CLAIM, Action.UPDATE),
    buildPermission(Resource.CLAIM, Action.DELETE),
  ],
  "masquer",
);
